import { render, staticRenderFns } from "./ProductMeasureComponent.vue?vue&type=template&id=de5d2a60&scoped=true"
import script from "./ProductMeasureComponent.vue?vue&type=script&lang=js"
export * from "./ProductMeasureComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductMeasureComponent.vue?vue&type=style&index=0&id=de5d2a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5d2a60",
  null
  
)

export default component.exports